import request from './axios';


// 获取进修须知
export function systemConfigTrainInstructionContentId() {
    return request({
        url: '/system/config/train-instruction-content-id',
        method: 'get',
    });
}
// 系统名称
export function systemConfigSysName() {
    return request({
        url: '/system/config/sys-name',
        method: 'get'
    });
}
// 系统logo
export function systemConfigSysLogo() {
    return request({
        url: '/system/config/sys-logo',
        method: 'get'
    });
}
// 系统登录背景图
export function systemConfigSysBackgroundImage() {
    return request({
        url: '/system/config/sys-backgroundImage',
        method: 'get'
    });
}
// 系统机构名称
export function systemConfigSysUnitName() {
    return request({
        url: '/system/config/sys-unitName',
        method: 'get'
    });
}
// 根据参数键名查询参数值
export function getConfigKey(configKey) {
    return request({
        url: '/system/config/configKey/' + configKey,
        method: 'get'
    });
}
// 获取图型验证码
export function getCaptcha(data) {
    return request({
        url: 'captchaImage',
        method: 'get',
        data: data
    });
}
// 注册
export function register(data) {
    return request({
        url: 'register',
        method: 'post',
        data: data
    });
}
// 登录
export function login(data) {
    return request({
        url: 'login',
        method: 'post',
        data: data,
        cancelToken:data.cancelToken,
    });
}
// 获取用户信息
export function getInfo(data) {
    return request({
        url: '/getInfo',
        method: 'get',
        data: data
    });
}
// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
    return request({
        url: 'system/dict/data/type/' + dictType,
        method: 'get'
    });
}
// 获取暂存信息
export function getApplyStorage(data) {
    return request({
        url: 'train/apply/storage',
        method: 'get'
    });
}
// 暂存信息
export function stagingApplyStorage(data) {
    return request({
        url: 'train/apply/storage',
        method: 'post',
        data: data
    });
}
// 退出方法
export function logout() {
    return request({
        url: 'logout',
        method: 'post'
    });
}
// 获取科室列表
export function getDeptList(params) {
    return request({
        url: 'system/train-dept',
        method: 'get',
        params
    });
}
// 查询科室进修方向列表
export function getDeptDirectionList(deptId) {
    return request({
        url: `/system/train-dept/${deptId}/direction`,
        method: 'get'
    });
}
// 发起申请提交
export function trainApply(data) {
    return request({
        url: 'train/apply',
        method: 'post',
        data: data,
        timeout: 20000
    });
}
// 获取申请详情信息
export function trainApplyDetail(id) {
    return request({
        url: `/train/apply/${id}`,
        method: 'get'
    });
}
export function trainApplyDetailAdmin(id) {
    return request({
        url: `/administrative/apply/${id}`,
        method: 'get'
    });
}
// 申请记录
export function trainApplySelectApplyList(data) {
    return request({
        url: '/train/apply/selectApplyList',
        method: 'get',
        params: data
    });
}
// 删除申请记录
export function trainApplyDelete(data) {
    return request({
        url: `/train/apply/${data}`,
        method: 'delete'
    });
}
// 上传申请表
export function trainApplyUploadSealed(id, data) {
    return request({
        url: `/train/apply/${id}/upload-sealed`,
        method: 'post',
        data: data
    });
}
// 上传单位介绍信
export function trainBasicUploadRecommendation(id, data) {
    return request({
        url: `/train/basic/${id}/upload-recommendation`,
        method: 'post',
        data: data
    });
}
// 上传健康证明
export function trainVasicUploadMedicalCertificate(id, data) {
    return request({
        url: `/train/basic/${id}/upload-medicalCertificate`,
        method: 'post',
        data: data
    });
}
// 上传其他
export function trainOtherCertificate(id, data) {
    return request({
        url: `/train/basic/${id}/upload-otherCertificates`,
        method: 'post',
        data: data
    });
}
// 上传结业鉴定
export function trainApplyJustUpdateApply(data) {
    return request({
        url: `/train/apply/justUpdateApply`,
        method: 'put',
        data: data
    });
}
// 证书发放记录
export function trainCertRecordList(data) {
    return request({
        url: `/train/cert/record/list`,
        method: 'get',
        params: data
    });
}
// 异常申请
export function trainAbnormal(data) {
    return request({
        url: `/train/abnormal`,
        method: 'post',
        data: data
    });
}
// 报到配置列表
export function systemAdmissionConfigList(data) {
    return request({
        url: `/system/admissionConfig/list`,
        method: 'get',
        data: data
    });
}
// 报到配置详情
export function admissionConfigDetail(nodeKey, id) {
    return request({
        url: `/system/admissionConfig/${nodeKey}/${id}`,
        method: 'get'
    });
}
// 视频列表
export function videoList(data) {
    return request({
        url: '/system/video/list',
        method: 'get',
        params: data
    });
}
// 报到流程刷新请求
export function confirmRegistration(data) {
    return request({
        url: '/train/apply/confirmRegistration/' + data,
        method: 'post'
    });
}
// 离院配置详情
export function leaveConfigDetail(nodeKey) {
    return request({
        url: `/system/leaveConfig/${nodeKey}`,
        method: 'get'
    });
}
// 获取登记信息
export function trainProcessDetail(id, data) {
    return request({
        url: `/train/process/getInfo/${id}`,
        method: 'get',
        data: data
    });
}
// 修改登记信息
export function trainProcessDetailModify(data) {
    return request({
        url: `/train/process`,
        method: 'put',
        data: data
    });
}
// 登记诊疗诊断技术
export function trainProcessDiagnosis(data) {
    return request({
        url: `/train/process/diagnosis`,
        method: 'post',
        data: data
    });
}
// 删除诊疗诊断技术
export function trainProcessDiagnosisRemove(id, data) {
    return request({
        url: `/train/process/diagnosis/${id}`,
        method: 'delete',
        data: data
    });
}
// 登记学习记录
export function trainProcessStudy(data) {
    return request({
        url: `/train/process/study`,
        method: 'post',
        data: data
    });
}
// 删除学习记录
export function trainProcessStudyRemove(id, data) {
    return request({
        url: `/train/process/study/${id}`,
        method: 'delete',
        data: data
    });
}
// 登记手术记录
export function trainProcessSurgery(data) {
    return request({
        url: `/train/process/surgery`,
        method: 'post',
        data: data
    });
}
// 删除手术记录
export function trainProcessSurgeryRemove(id, data) {
    return request({
        url: `/train/process/surgery/${id}`,
        method: 'delete',
        data: data
    });
}
// 上传报到节点附件
export function trainAdmissionNodeUploadAttCheckIn(data) {
    return request({
        url: `/train/admissionNode/uploadAttCheckIn`,
        method: 'put',
        data: data
    });
}
// 上传离院节点附件
export function trainLeaveNodeUploadLeaveNodeAtt(data) {
    return request({
        url: `/train/leaveNode/uploadLeaveNodeAtt`,
        method: 'put',
        data: data
    });
}

//获取验证图片
export function reqGet(data) {
    return request({
        url: '/captcha/get',
        method: 'post',
        data
    });
}

//滑动或者点选验证
export function reqCheck(data) {
    return request({
        url: '/captcha/check',
        method: 'post',
        data
    });
}

// 发送短信验证码
export function sendSmsCode(data) {
    return request({
        url: '/sms/code',
        method: 'post',
        data: data
    });
}

// 发送短信验证码
export function retrievePwd(data) {
    return request({
        url: '/retrieve-pwd',
        method: 'post',
        data: data
    });
}
// 专科类型下拉列表
export function trainSpecialtyCategory(data) {
    return request({
        url: `/train/specialty/category`,
        method: 'get',
        params: data
    });
}
// 专科下拉列表
export function trainSpecialty(data) {
    return request({
        url: `/train/specialty`,
        method: 'get',
        params: data
    });
}
// 内容
export function trainContent(id, data) {
    return request({
        url: `/train/content/${id}`,
        method: 'get',
        params: data
    });
}
// 通知公告
export function trainAnnouncementList(data) {
    return request({
        url: `/train/announcement/list`,
        method: 'get',
        params: data
    });
}
// 获取考核信息
export function trainApplyGetAssessment(id, data) {
    return request({
        url: `/train/apply/getAssessment/${id}`,
        method: 'get',
        params: data
    });
}
// 提交考核信息
export function trainApplyUpdateAssessment(data) {
    return request({
        url: `/train/apply/updateAssessment`,
        method: 'put',
        data: data
    });
}
export function trainApplyStorageAssessmentPost(data) {
    return request({
        url: `/train/apply/storageAssessment`,
        method: 'post',
        data: data
    });
}
// 获取暂存考核信息
export function trainApplyStorageAssessment(applyId) {
    return request({
        url: `/train/apply/storageAssessment/${applyId}`,
        method: 'get'
    });
}
// 进修撤销申请
export function trainApplyRevokeApplication(data) {
    return request({
        url: `/train/apply/revokeApplication`,
        method: 'put',
        data: data
    });
}


// 护理接口
// 暂存护理申请信息
export function setStorageNurseApplyInfo(data) {
    return request({
        url: `/train/apply/setStorageNurseApplyInfo`,
        method: 'post',
        data
    });
}
// 获取暂存护理申请信息
export function getStorageNurseApplyInfo(data) {
    return request({
        url: `/train/apply/getStorageNurseApplyInfo`,
        method: 'get'
    });
}
// 提交护理申请信息
export function submitApplication(data) {
    return request({
        url: `/train/apply/submitApplication`,
        method: 'post',
        data
    });
}
export function systemDirectionList(data) {
    return request({
        url: `/system/direction/list`,
        method: 'get',
        params: data
    });
  }
  export function nurseDirectionList(data) {
    return request({
        url: `/nurse/train/dept/list`,
        method: 'get',
        params: data
    });
  }
  export function testDate(data) {
    return request({
        url: `/train/apply/verify/restrictionDate/${data}`,
        method: 'post',
        data: data
    });
  }
export function adminDirectionList(data) {
  return request({
      url: `/administrative/list`,
      method: 'get',
      params: data
  });
}
// 暂存信息
export function stagingApplyStorageAdmin(data) {
    return request({
        url: '/administrative/apply/setStorageAdministrativeInfo',
        method: 'post',
        data: data
    });
}
export function trainApplyAdmin(data) {
    return request({
        url: '/administrative/apply/submit',
        method: 'post',
        data: data,
        timeout: 20000
    });
}
export function getApplyStorageAdmin(data) {
    return request({
        url: '/administrative/apply/getStorageAdministrativeInfo',
        method: 'get'
    });
}
export function getConfig(configId) {
  return request({
    url: '/system/config/' + configId,
    method: 'get'
  })
}
